<template>
	<div class="page-privacy">
		<!--悬浮头部-->
		<Header></Header>
		<!--banner-->
		<div class="banner">
			<img src="https://krk-website.oss-cn-beijing.aliyuncs.com/img/privacy/map_banner.jpg" />			
		</div>
		<div class="privacy-section">
			<div class="header w1200 clearfix">
				<div class="header-left">
					<div class="hr"></div>
					<h2>网站地图</h2>
				</div>
				<div class="header-right">Site Map</div>
			</div>
			<div class="contents_wrap">
				<div class="contents">
          <ul>
            <p @click.stop="index()">首页<span>>></span></p>
            <li>KRK视频</li>
            <li>家长预约</li>
            <li>活动日历</li>
            <li>新闻动态</li>
            <li>加入我们</li>
          </ul>
          <ul>
            <p @click.stop="">关于KRK<span>>></span></p>
            <li>半个世纪的故事</li>
            <li>爱在中国 </li>
            <li>KRK信念</li>
            <li>国际团队</li>           
          </ul>
          <ul>
            <p @click.stop="">选择KRK<span>>></span></p>
            <li>核心优势</li>
            <li>专业课程</li>
            <li>QA体系</li>
            <li>透明管理</li>   
            <li>食品健康</li>
            <li>家长说</li>           
          </ul>
          <ul>
            <p @click.stop="">加入KRK<span>>></span></p>
            <li>给新家长的一封信</li>
            <li>KRK大家庭</li>
            <li>KRK工作和生活</li>
            <li>立刻申请</li>             
          </ul>
          <ul class="last">
            <p @click.stop="">其他<span>>></span></p>
            <li>Kids ‘R’ Kids美国总部</li>
            <li>隐私政策</li>           
          </ul>
        </div>
			</div>             			
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
import Header from "@/components/header/Header"; //悬浮头部
import Footer from "@/components/footer/footer"; //底部模块
export default {
  data() {
    return {};
  },
  mounted() {},
  components: {
    Header,
    "v-footer": Footer
  },
  mounted() {},
  beforeRouteUpdate() {},
  methods: {
    index() {
      //跳转到网站地图页面
      this.$router.push({ name: "index" });
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
@import "@/assets/css/variables.scss";
.page-privacy {
  .banner {
    width: 100%;
    position: relative;
    img {
      display: block;
      width: 100%;
    }
    .content {
      position: absolute;
      left: 50%;
      margin-left: -600px;
      bottom: 0;
      height: 68px;
      li {
        position: relative;
        width: 228px;
        height: 68px;
        float: left;
        background: rgba(0, 0, 0, 0.6);
        text-align: center;
        cursor: pointer;
        div.title {
          p {
            width: 100%;
            height: 68px;
            font-size: 24px;
            font-family: PingFangSC-Regular;
            color: rgba(255, 255, 255, 1);
            line-height: 68px;
            position: relative;
          }
          ul {
            display: none;
            position: absolute;
            top: -206px;
            left: 0;
            width: 456px;
            height: 204px;
            background: rgba(0, 52, 121, 0.8);
            cursor: pointer;
            li {
              width: 415px;
              height: 36px;
              margin: 2px 20px;
              font-size: 16px;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              line-height: 36px;
              color: #fff;
            }
          }
          ul .cour:hover {
            background: rgba(0, 43, 101, 0.8);
          }
        }
      }
      li:first-child :hover ul {
        display: block;
      }
      .active {
        background: rgba(0, 40, 93, 1);
      }
      li:hover {
        background: rgba(0, 40, 93, 1);
      }
      li:hover .cour {
        background: 0;
      }
    }
  }
  .privacy-section {
    width: 100%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    .w1200 {
      width: 1200px !important;
      margin: 0 auto;
    }
    .header {
      width: 1200px;
      height: 110px;
      overflow: hidden;
      margin-top: 126px;
      margin-bottom: 100px;
      .header-left {
        float: left;
        .hr {
          width: 96px;
          height: 4px;
          background: rgba(174, 149, 79, 1);
        }
        h2 {
          width: 375px;
          height: 96px;
          font-size: 48px;
          font-family: PingFangSC-Medium;
          font-weight: 500;
          color: #333333;
          line-height: 96px;
        }
        h3 {
          width: 180px;
          height: 29px;
          line-height: 29px;
          background: rgba(174, 149, 79, 1);
          font-size: 24px;
          font-family: TimesNewRomanPS-BoldItalicMT;
          font-weight: bold;
          font-style: italic;
          color: rgba(255, 255, 255, 1);
          text-align: center;
        }
      }
      .header-right {
        float: right;
        width: 390px;
        margin-top: 16px;
        margin-right: 20px;
        height: 73px;
        font-size: 73px;
        font-family: TimesNewRomanPS-ItalicMT;
        font-style: italic;
        color: rgba(204, 204, 204, 1);
        line-height: 73px;
        text-align: right;
      }
    }
    .contents_wrap {
      width: 100%;
      height: 944px;
      margin: 0 auto;
      background: rgba(255, 255, 255, 1);
      .contents {
        margin: 0 auto;
        width: 1200px;
        height: 500px;
        text-align: left;
        position: relative;
        ul {
          float: left;
          width: 200px;
          margin-right: 50px;
          height: auto;
          p {
            width: 200px;
            font-size: 22px;
            font-family: PingFangSC-Semibold;
            font-weight: 600;
            text-decoration: underline;
            color: rgba(51, 51, 51, 1);
            line-height: 44px;
            margin-bottom: 11px;
            cursor: pointer;
            span {
              color: rgba(174, 149, 79, 1);
              margin-left: 15px;
              text-decoration: none;
            }
          }
          li {
            width: 200px;
            font-size: 16px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            text-decoration: underline;
            color: rgba(51, 51, 51, 1);
            line-height: 40px;
            cursor: pointer;
          }
          li:hover {
            color: rgba(0, 52, 120, 1);
          }
        }
        .last {
          margin-right: 0px;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .page-privacy {
    .banner {
      padding-top: 45px;
    }
    .privacy-section {
      .w1200 {
        width: 100%!important;
        margin: 0 auto!important;
      }
      .header {
        width: 100%;
        height: 60px;
        overflow: hidden;
        margin-top: 39px!important;
        box-sizing: border-box;
        padding-left: 8%;
        .header-left {
          width: 100%;
          .hr {
            width: 56px;
            height: 3px;
          }
          h2 {
            width: 100%;
            height: 22px;
            font-size: 21px;
            line-height: 22px;
            padding-top: 11px;
          }
        }
        .header-right {
          display: none;
        }
      }
      .contents_wrap {
        width: 100%;
        height: 900px;
        margin: 0 auto;
        color: rgba(255, 255, 255, 1);
        .contents {
          margin: 0 auto;
          width: 100%;
          height: 900px;
          text-align: left;
          position: relative;
          p {
            width: 100%;
            padding: 0 8%;
            box-sizing: border-box;
            height: auto;
            font-size: 14px;
            line-height: 28px;
            margin-bottom: 30px;
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/other/sitemap.vue